<template>
  <div class="social-strategy-container">
    <div class="header">
      <h1 class="page-title">SOCIAL STRATEGY</h1>
      <button v-if="socialStrategyList.length > 0" class="create-button" @click="showCreateDialog = true">
        <Svg :src="require('@/assets/icons/add.svg')" alt="add"></Svg>

        <span>Create</span>

      </button>
    </div>

    <div v-if="draftCount > 0 || completeCount > 0 || filterState" class="tabs-container">

      <div class="toggle-buttons">
        <button class="toggle-button" :class="{ active: selectedTab === 'draft' }" @click="toggleTab('draft')">
          DRAFT<span> ({{ draftCount }})</span>
        </button>
        <button class="toggle-button" :class="{ active: selectedTab === 'complete' }" @click="toggleTab('complete')">
          COMPLETE <span>({{ completeCount }})</span>
        </button>
      </div>
      <div class="filter-Page" v-if="showFilter">
        <v-menu v-model="dateMenu" :close-on-content-click="false">
          <template v-slot:activator="{ props }">
            <div class="selected-date-container">
              <button class="filter-btn" v-bind="props">
                <Svg :src="require('@/assets/icons/calendar.svg')" stroke='#030712'></Svg>
                <span v-if="displayDateValue">{{ displayDateValue }}</span>
                <span class="text" v-else>Filter by Date</span>
              </button>
              <v-icon v-if="filterStartDate" @click="clearFilterDates">mdi-close</v-icon>
            </div>
          </template>
          <v-date-picker v-model="selectedDate" :max="new Date()" multiple="range"
            @update:model-value="updateFilterDate(false)">
            <template #actions>
              <div class="action-btns">
                <v-btn @click="clearFilterDates" class="ok-btn">Cancel</v-btn>
                <v-btn @click="updateFilterDate(true)" class="ok-btn" :disabled="selectedDate.length === 0">OK</v-btn>
              </div>
            </template>
          </v-date-picker>
        </v-menu>

        <div class="view-toggle-container">
          <button @click="selectedView = 'list'" :class="{ 'active': selectedView === 'list', 'view-icon': true }">
            <img :src="require('@/assets/icons/list.svg')" alt="list">
          </button>
          <button @click="selectedView = 'grid'" :class="{ 'active': selectedView === 'grid', 'view-icon': true }">
            <img :src="require('@/assets/icons/grid.svg')" alt="grid">
          </button>
        </div>
      </div>
    </div>

    <div v-if="tableLoader" class="loading-container">
      <RotatingLoader :size="30" :speed="0.6" label="Loading..." />
    </div>

    <div v-else-if="socialStrategyList.length > 0" style="height: 85%;">
      <div v-if="selectedView === 'list'" class="table-container" style="height: 100%;">
        <v-data-table class="table-wrapper" :headers="tableHeaders" :items="socialStrategyList" :hover="true"
          :items-per-page="itemsPerPage" :page="page" @click:row="redirectToDetailsPage">
          <template v-slot:[`item.createdBy`]="{ item }">
            <div class="avatar">
              <img v-if="item.profileAvatar" :src="item.profileAvatar" class="profile-icon" alt="User Avatar" />
              <div class="profile-icon no-avatar" v-else>
                {{ item?.createdByName?.[0] }}
              </div>
              <div class="author">{{ item.createdByName }}</div>
            </div>
          </template>

          <template v-slot:[`item.createdAt`]="{ item }">
            {{ convertEpochToDate(item.createdAt) }}
          </template>

          <template v-slot:[`item.updatedAt`]="{ item }">
            {{ convertEpochToDate(item.updatedAt) }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-menu v-model="item.showMoreMenu" :close-on-content-click="false">
              <template v-slot:activator="{ props }">
                <div class="more-button-wrapper">
                  <img style="height: 16px; width: 16px;" :src="require('@/assets/icons/more.svg')" alt="more"
                    v-bind="props">
                </div>
              </template>
              <div class="more-options-contaioner">
                <div @click="renameStrategy(item)" class="bottom-border more-option-img-wrapper">
                  <img :src="require('@/assets/icons/rename.svg')" alt="rename">
                  <p>Rename</p>
                </div>
                <div class="more-option-img-wrapper" @click="openDeleteDialog(item)">
                  <img :src="require('@/assets/icons/delete.svg')" alt="delete" style="filter: brightness(0);">
                  <p>Delete</p>
                </div>
              </div>
            </v-menu>
          </template>
        </v-data-table>
      </div>

      <div v-else-if="selectedView === 'grid'" class="strategy-grid">
        <div v-for="(item, index) in socialStrategyList" :key="index" class="strategy-card"
          @click="redirectToDetailsPage(null, { item })">
          <div class="strategy-more-container">
            <div class="strategy-content">{{ item.docTitle }}</div>
            <div class="more-container">
              <v-menu v-model="item.showMoreMenu" :close-on-content-click="false">
                <template v-slot:activator="{ props }">
                  <img :src="require('@/assets/icons/more.svg')" alt="more" v-bind="props">
                </template>
                <div class="more-options-container">
                  <div @click="renameStrategy(item)" class="bottom-border more-option-img-wrapper">
                    <img :src="require('@/assets/icons/rename.svg')" alt="rename">
                    <p>Rename</p>
                  </div>
                  <div class="more-option-img-wrapper" @click="openDeleteDialog(item)">
                    <img :src="require('@/assets/icons/delete.svg')" alt="delete" style="filter: brightness(0);">
                    <p>Delete</p>
                  </div>
                </div>
              </v-menu>
            </div>
          </div>
          <div class="strategy-footer">
            <div class="avatar">
              <img v-if="item.profileAvatar" :src="item.profileAvatar" class="profile-icon" alt="User Avatar" />
              <div class="profile-icon no-avatar" v-else>
                {{ item?.createdByName?.[0] }}
              </div>
              <div class="author">{{ item.createdByName }}</div>
            </div>
            <div class="meta-info">
              <div class="timestamp">{{ convertUpdatedTime(item.updatedAt).date }}</div>
              <div class="seperator"></div>
              <div class="timestamp">{{ convertUpdatedTime(item.updatedAt).time }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-else class="empty-state-wrapper">
      <EmptyState v-if="filterState && selectedTab === 'draft'" title="No Drafted Social Strategies!" stage="DRAFT"
        :filter="filterState" subTitle="No Social Strategies matches your filters."
        @create-dialog="showCreateDialog = true" />
      <EmptyState v-else-if="filterState && selectedTab === 'complete'" title="No Completed Social Strategies!"
        stage="COMPLETED" subTitle="No Social Strategies matches your filters."
        @create-dialog="showCreateDialog = true" />

      <EmptyState v-else title="No Social Media Campaign Created!"
        subTitle="Create a new Social Media Campaign to see it listed here." stage="DRAFT"
        @create-dialog="showCreateDialog = true" />
    </div>
    <CreatePopup v-if="showCreateDialog" v-model="showCreateDialog" :flowtype="'Social Media Campaign'"
      @create="addNewSocialStrategy($event)" />

    <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
      @confirm-action="handlePopupConfirmation" />

    <RenamePopup v-if="isEditing" :docName="currentRenameItem.docTitle" :id="currentRenameItem.socialStrategyId"
      :isEditing="isEditing" @update-isEdit="isEditing = $event" @updated-prTitle="handleTitleUpdate($event)"
      flowType="socialStrategy" />
  </div>
</template>

<script>
import EmptyState from '@/components/EmptyState.vue';
import RotatingLoader from '@/components/CircularProgressBar.vue';
import CommonPopup from '@/components/CommonPopup.vue';
import RenamePopup from '@/components/RenamePopup.vue';
import moment from 'moment-timezone';
import axiosInstance from '@/axiosInterceptor';
import { Eventbus } from '@/plugins/eventBus';
import CreatePopup from '@/components/CreatePopup.vue';

export default {
  name: 'SocialStrategy',
  components: {
    EmptyState,
    RotatingLoader,
    CommonPopup,
    RenamePopup,
    CreatePopup
  },

  data() {
    return {
      showCreateDialog: false,
      showCommonPopup: false,
      isEditing: false,
      docName: null,
      isFormValid: false,
      createBtnLoader: false,
      tableLoader: false,
      socialStrategyList: [],
      draftCount: 0,
      completeCount: 0,
      selectedTab: 'draft',
      selectedView: 'grid',
      itemsPerPage: 10,
      page: 1,
      selectedDate: [],
      filterStartDate: null,
      filterEndDate: null,
      dateMenu: false,
      displayDateValue: null,
      tableHeaders: [
        { title: 'Document Name', key: 'docTitle' },
        { title: 'Created By', key: 'createdBy' },
        { title: 'Created Date', key: 'createdAt' },
        { title: 'Last Edited', key: 'updatedAt' },
        { title: 'Actions', key: 'actions' },
      ],
      popupType: null,
      itemToDelete: null,
      currentRenameItem: {},
      filterState: false
    };
  },

  computed: {
    showFilter() {
      if (this.filterState) {
        return true;
      } else if (this.selectedTab === 'draft' && this.draftCount > 0) {
        return true;
      } else if (this.selectedTab === 'complete' && this.completeCount > 0) {
        return true;
      }
    }
  },

  watch: {
    showCreateDialog(val) {
      if (!val) {
        this.resetPopupData();
      }
    }
  },

  async mounted() {
    await this.fetchSocialStrategies();
  },

  methods: {

    async fetchSocialStrategies() {
      this.tableLoader = true;
      try {
        let params = {};
        if (this.filterStartDate && this.filterEndDate) {
          params.startDate = new Date(this.filterStartDate).getTime();
          params.endDate = new Date(this.filterEndDate).getTime();
          this.filterState = true;
        }

        const response = await axiosInstance.get('/socialMedia', {
          params
        });

        const allData = response.data.data || [];

        const draftItems = allData.filter(item => item.statusValue === 'DRAFT').sort((a, b) => b.updatedAt - a.updatedAt);
        const completedItems = allData.filter(item => item.statusValue === 'COMPLETED').sort((a, b) => b.updatedAt - a.updatedAt);

        this.draftCount = draftItems.length;
        this.completeCount = completedItems.length;

        this.socialStrategyList = this.selectedTab === 'draft' ? draftItems : completedItems;

      } catch (error) {
        this.socialStrategyList = [];
        this.draftCount = 0;
        this.completeCount = 0;
        this.filterState = false;
        this.showErrorSnackbar('Failed to load social strategies');
      } finally {
        this.tableLoader = false;
      }
    },

    toggleTab(tab) {
      this.selectedTab = tab;
      this.fetchSocialStrategies();
    },

    async addNewSocialStrategy(docName) {
      this.createBtnLoader = true;
      try {
        const response = await axiosInstance.post('/socialMedia/create', {
          docName: docName
        });

        if (response.data?.data?.socialStrategyId) {
          this.redirectToDetailsPage(null, {
            item: { socialStrategyId: response.data.data.socialStrategyId }
          });
        }

        this.closeCreateDialog();
        await this.fetchSocialStrategies();

      } catch (error) {
        console.error('Failed to create Social Media Campaign:', error);
        this.showErrorSnackbar('Failed to create Social Media Campaign');
      } finally {
        this.createBtnLoader = false;
      }
    },

    renameStrategy(item) {
      this.isEditing = true;
      this.currentRenameItem = item;
    },

    async handleTitleUpdate(newTitle) {
      this.currentRenameItem.docTitle = newTitle;
      await this.fetchSocialStrategies();
    },

    openDeleteDialog(item) {
      this.itemToDelete = item;
      this.popupType = 'delete';
      this.showCommonPopup = true;
    },

    async handlePopupConfirmation(confirmed) {
      this.showCommonPopup = false;

      if (confirmed === 'yes' && this.popupType === 'delete' && this.itemToDelete) {
        await this.deleteStrategy(this.itemToDelete);
      }

      this.resetPopupStates();
    },

    async deleteStrategy(item) {
      this.tableLoader = true;
      try {
        const response = await axiosInstance.put('/socialMedia/delete', {
          socialStrategyId: item.socialStrategyId
        });

        if (response.status === 200) {
          this.showSuccessSnackbar('Social Media Campaign deleted successfully');
          await this.fetchSocialStrategies();
        }

      } catch (error) {
        console.error('Failed to delete Social Media Campaign:', error);
        this.showErrorSnackbar('Failed to delete Social Media Campaign');
      } finally {
        this.tableLoader = false;
      }
    },

    closeCreateDialog() {
      this.showCreateDialog = false;
      this.resetPopupData();
    },

    resetPopupData() {
      this.docName = '';
      this.isFormValid = false;
    },

    resetPopupStates() {
      this.popupType = null;
      this.itemToDelete = null;
    },

    async updateFilterDate(okBtnClicked) {
      if (this.selectedDate.length > 1) {
        this.filterStartDate = moment(this.selectedDate[0]).valueOf();
        this.filterEndDate = moment(this.selectedDate[this.selectedDate.length - 1]).valueOf();
        this.displayDateValue = moment(this.selectedDate[0]).format('DD/MM/YYYY') + ' - ' + moment(this.selectedDate[this.selectedDate.length - 1]).format('DD/MM/YYYY');
        this.dateMenu = false;
        this.fetchSocialStrategies();
      } else if (okBtnClicked) {
        this.filterStartDate = moment(this.selectedDate[0]).valueOf();
        this.filterEndDate = moment(this.selectedDate[0]).endOf('day').valueOf();
        this.displayDateValue = moment(this.selectedDate[0]).format('DD/MM/YYYY');
        this.dateMenu = false;
        this.fetchSocialStrategies();
      }
    },

    clearFilterDates() {
      this.selectedDate = [];
      this.filterStartDate = null;
      this.filterEndDate = null;
      this.dateMenu = false;
      this.displayDateValue = null;
      this.filterState = false;
      this.fetchSocialStrategies();
    },

    removeNumbers() {
      this.docName = this.docName.replace(/[0-9]/g, '');
    },

    convertEpochToDate(time) {
      return moment(time).format('DD/MM/YYYY');
    },
    convertUpdatedTime(date) {
      return {
        date: moment(date).format("Do MMM, YYYY"),
        time: moment(date).format("hh:mmA")
      };
    },

    convertUpdatedDate(date) {
      return moment(date).format("Do MMM YYYY");
    },

    redirectToDetailsPage(event, { item }) {
      if (!item?.socialStrategyId) return;

      this.$router.push({
        name: 'SocialStrategyDetails',
        params: { socialStrategyId: item.socialStrategyId }
      });
    },

    showErrorSnackbar(message) {
      Eventbus.emit('commonSnackbar', {
        snackType: 'error',
        message
      });
    },

    showSuccessSnackbar(message) {
      Eventbus.emit('commonSnackbar', {
        snackType: 'save',
        message
      });
    }
  }
};
</script>

<style scoped>
.social-strategy-container {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: white;
  border-radius: 16px;
  gap: 1rem;
  min-height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-title {
  font-size: 2rem;
  font-weight: bold;
  font-family: 'OverpassMono', monospace;
  color: #333;
  margin: 0;
}

.create-button {
  display: flex;
  background: black;
  flex-direction: row;
  color: var(--secondary-font-color);
  border-radius: 8px;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem 1.8rem;
  font-family: 'OverpassMono';
}


.tabs-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.toggle-buttons {
  display: flex;
  gap: 10px;
  border: 1px solid #A3A3A3;
  padding: 4px;
  border-radius: 8px;
}

.toggle-button {
  padding: 10px 30px;
  border-radius: 8px;
  font-family: 'OverpassMono';
  text-transform: uppercase;
  background: white;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

.toggle-button.active {
  background-color: black;
  color: white;
}

.toggle-button:hover {
  background-color: black;
  color: white;
}

.filter-Page {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.selected-date-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 4px 12px;
  border-radius: 8px;
  border: 1px solid #D4D4D4;
  color: #030712;
  background: white;
  cursor: pointer;
}

.view-toggle-container {
  display: flex;
  border: 1px solid #D4D4D4;
  height: 40px;
  border-radius: 8px;
  overflow: hidden;
}

.view-icon {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: white;
  border: none;
  cursor: pointer;
}

.view-icon.active {
  background-color: #F1F4FB;
}

.view-icon:first-child {
  border-right: 1px solid #D4D4D4;
}

.table-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 85%;
  justify-content: space-between;
}

.table-wrapper {
  border-radius: 8px;
  height: 100%;
  scrollbar-width: thin;
  will-change: transform;
  justify-content: center;
  align-items: end;
}

.table-container :deep(.v-table__wrapper tr:hover) {
  background: #F1F4FB !important;
}

.table-wrapper :deep(.v-table__wrapper) {
  width: 100%;
  scrollbar-width: thin;
  border: 1px solid #E5E5E5;
}

.table-wrapper :deep(.v-table__wrapper thead) {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #F1F4FB !important;
}

.table-wrapper :deep(.v-table__wrapper thead tr th) {
  font-weight: 600 !important;
  color: var(--primary-font-color);
}

.table-wrapper :deep(.v-table__wrapper tbody) {
  max-height: 700px;
  color: var(--dark-grey-color);
}

.table-wrapper :deep(.v-data-table-footer) {
  background: #F1F4FB !important;
  padding: 0rem 0rem 0rem 1rem;
  margin: 1rem;
  height: 5rem;
  border-radius: 8px;
  border: 1px solid #E5E5E5;
}

.table-wrapper :deep(.v-data-table-footer .v-pagination__list .v-pagination__first) {
  display: none;
}

.table-wrapper :deep(.v-data-table-footer .v-pagination__list .v-pagination__last) {
  display: none;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control) {
  height: 2rem;
  width: 4rem;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__input) {
  padding: 0px 16px 8px 16px;
  font-size: 14px;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__field) {
  height: 2rem;
  width: 3rem;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__append-inner) {
  width: 1rem;
}

.table-wrapper :deep(.v-data-table-footer .v-data-table-footer__items-per-page > .v-select) {
  width: 63px;
  background: #F1F4FB;
}

.avatar {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
}

.profile-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  overflow: hidden;
  font-size: 14px;
}

.no-avatar {
  background: linear-gradient(90deg, #FF00C3, #FF0A19, #FF7800);
  color: white;
}

.author {
  font-weight: 500;
}

.more-button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #E5E5E5;
  width: 2rem;
  height: 2rem;
  border-radius: 8px;
}

.more-options-contaioner,
.more-options-container {
  min-width: 180px;
  display: flex;
  flex-direction: column;
  background: white;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px #0000000F, 0px 0px 4px 0px #0000000A;
}

.more-option-img-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  padding: 1rem;
}

.bottom-border {
  border-bottom: 1px solid #E5E5E5;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;

}

.empty-state-wrapper {
  display: flex;
  flex-direction: column;
  padding: 2rem;
  border: 1px solid #E5E5E5;
  border-radius: 12px;
  background-color: #FAFAFA;
  gap: 20px;
  flex: 1;
}

.popup-content {
  display: flex;
  flex-direction: column;
  background: white;
  border: 1px solid #E0E9ED;
  border-radius: 8px;
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  font-weight: 600;
  font-family: 'OverpassMono';
  font-size: 20px;
}

.nn-title {
  font-size: 1.25rem;
  font-weight: bold;
}

.circle {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 8px;
  border: 2px solid #D4D4D4;
  background: none;
  cursor: pointer;
}

.popup-body {
  display: flex;
  flex-direction: column;
  gap: 4em;
  padding: 16px;
  overflow: auto;
  height: 100%;
}

.popup-footer {
  display: flex;
  justify-content: space-between;
  gap: 1em;
}

.add-new-btn-continue {
  display: flex;
  align-items: center;
  gap: 25px;
  justify-content: center;
  width: 50%;
  background: #171717;
  color: white;
  border: 1px solid #525252;
  border-radius: 8px;
  font-weight: 500;
  padding: 12px;
  cursor: pointer;
}

.add-new-btn {
  width: 50%;
  padding: 12px;
  background: white;
  border: 1px solid #525252;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.popup-input {
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-weight: 500;
}

.label {
  font-weight: 500;
}

.strategy-grid {
  display: grid;
  overflow: auto;
  will-change: transform;
  scrollbar-width: thin;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  max-height: 100%;
  padding-bottom: 1rem;
}

.strategy-card {
  display: flex;
  gap: 16px;
  border: 1px solid #E5E5E5;
  background: #FAFAFA;
  flex-direction: column;
  padding: 1rem;
  border-radius: 8px;
  cursor: pointer;
}

.strategy-more-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.strategy-content {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  font-weight: 600;
}

.strategy-footer {
  display: flex;
  padding-top: 12px;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #E5E5E5;
  font-size: 14px;
  color: #525252;
}

.filter-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.meta-info {
  color: #ccc;
  display: flex;
  gap: 4px;
  align-items: center;
  flex-direction: row;
}

.timestamp {
  font-weight: 500;
  color: #A3A3A3;
}
</style>